export default {
  // 全局设置
  globalSettings: {
    roleAuthInfo:
      '角色权限控制用户可以使用哪些模块、功能以及可查看的数据权限; 角色请在【角色管理】中去创建',
    dataAuth: '数据权限',
    funAuth: '功能权限',
    seeMyData: '仅查看本人数据',
    seeMyDepartment: '查看本部门数据',
    seeCompanyData: '查看全机构数据',
    conteneUpdateIsSave: '内容有更新, 是否需要保存?',
    pageAuthInfo: '显示机构所有角色, 通过角色查看不同业务类型数据时所使用的页面布局',
    dataShareInfo: '将符合某一条件的数据集作为一个数据区域自动共享给某一角色、成员、组织架构',
    dataShare: '数据共享',
    ruleContion: '规则条件',
    anyContion: '任何条件',
    zhidingContion: '指定条件',
    matchContion: '选择匹配条件',
    shareTarget: '共享目标',
    VisitRule: '访问权限',
    selectSharer: '请选择分享人',
    delRuleIsGoon: '此操作将永久删除该规则, 是否继续?',
    recordLockingInfo: '将符合某一条件的数据自动锁定',
    lockingRecordAfter: '锁定记录后',
    recordLocking: '记录锁定',
    dontEdit: '不可编辑',
    dontShare: '不可共享',
    dontTransPer: '不可转移负责人',
    dontZhuanhuan: '不可转换',
    dontDel: '不可删除',
    referenceMappingInfo:
      '应用于“关联关系”类型字段, 设置关联关系可以将关联字段模块中的字段内容依赖到当前模块中',
    controlField: '控制字段',
    firstControlField: '一级控制字段',
    secondControlField: '二级控制字段',
    referenceMapping: '关联映射',
    mappingField: '映射字段',
    duiyingField: '对应字段',
    addIsRepeatEdit: '新增的规则已经存在, 请使用编辑功能',
    controlFielNotEmpty: '控制字段不能为空',
    firstControlFielNotEmpty: '一级控制字段不能为空',
    secondControlFielNotEmpty: '二级控制字段不能为空',
    controlFieldDontSame: '一级控制字段和二级控制字段不可一致',
    mapDuiyingFieldNotEmpey: '映射字段、对应字段均不能为空',
    mapDelIsgoon: '此操作将永久删除, 是否继续?',
    referenceYilaiInfo: '应用于为“关联关系”类型的字段, 实现两个关联关系之间的数据过滤',
    yilaiField: '依赖字段',
    referenceYilai: '关联依赖',
    controlAndYilaiField: '控制字段和依赖字段不可相互控制和依赖',
    yilaiFieldNotEmpty: '依赖字段不能为空',
    controlAndYilaiDontLike: '控制字段和依赖字段不可一致',
    controlAndControl2DontLike: '一级控制字段和二级控制字段不可一致',
    optionFieldYilaiInfo: '应用于“下拉选项”类型字段, 选择一个控制字段和一个依赖字段进行过滤依赖',
    optionYilai: '选项依赖',
    optionFieldYilai: '选项字段依赖',
    controlOption: '控制选项',
    firstControlOption: '一级控制选项',
    secondControlOption: '二级控制选项',
    yilaiOption: '依赖选项',
    optionControlInfo: '应用于“下拉选项”类型字段, 通过选项控制下面字段是否显示',
    optionControl: '选项控制',
    option: '选项',
    referenceField: '关联字段',
    checkedReferenceShow: '勾选后关联显示',
    pleaseSelectOptionList: '请先选择选项字段的下拉选项',
    pleaseSelectControlList: '请先选择控制字段的下拉选项',
    dataLinkageInfo: '对已有的表单数据进行预计算(预处理), 以备进一步调用',
    linkageForm: '联动表单',
    linkageContion: '联动条件',
    linkageField: '联动字段',
    dataLinkage: '数据联动',
    triggerLinkageField: '触发联动字段',
    thisModule: '本模块',
    valueEqualTo: '的值等于',
    valueTime: '的值时',
    value: '的值',
    linkageShow: '联动显示',
    linkageFormNotEmpty: '联动表单不能为空',
    linkageContionNotEmpty: '联动条件不能为空',
    linkageFieldNotEmpty: '联动字段不能为空',
    subformOptionMappingInfo:
      '应用于“主子表关联映射”, 在子表单中生成按钮, 通过主表关联过滤后将子表单数据批量插入',
    subformOptionMapping: '子表单选项映射',
    thisModuleSubform: '本模块子表单',
    referenceSubform: '关联子表单',
    filterContion: '过滤条件',
    addFilterContion: '添加过滤条件',
    subformMappingGuanxi: '子表单映射关系',
    selectSubfrom1: '请选择本模块子表单',
    selectSubfrom2: '请选择关联子表单',
    fieldTransfer: '字段转换',
    fieldTransferInfo: '将字段转换到对应的其他模块中, 再转换时将使用这些映射',
    addFieldTransfer: '新增字段转换',
    baseInfo: '基础信息',
    sourceModule: '源模块',
    targetModule: '目标模块',
    jumpSystem: '跳转链接',
    isJumpPolaris: '是否跳转北极星',
    jump: '跳转',
    notJump: '不跳转',
    polarisLink: '北极星链接',
    pleaseInputPolarisLink: '请输入北极星链接',
    ifDelSourceRecord: '是否删除原有记录?',
    fieldDuiyingGuanxi: '字段对应关系',
    selectSubfrom: '选择子表单',
    selectTransferTargetModule: '请选择转换的目标模块',
    cancelDel: '已取消删除',
    autoMarkColor: '自动标记颜色',
    autoMarkColorInfo: '将符合某一条件的数据自动标记颜色。',
    markColor: '标记颜色',
    showColor: '显示颜色',
    customPrint: '自定义打印',
    customPrintInfo: '打印模块数据时可选择设置好的模板格式进行打印',
    templateName: '模板名称',
    type: '类型',
    uploadTemplate: '上传模版',
    addFile: '添加文件',
    exportTemplate: '导出模板',
    exampleTemplateDown: '示例模版下载',
    printTemplate: '打印模版',
    uploadXlsFile: '请上传 xls 类型文件',
    uploadDocxFile: '请上传 docx 类型文件',
    uploadPrintTemplate: '请上传打印模版',
    delTemplateIsGoon: '此操作将永久删除该模版, 是否继续?',
    outLink: '数据外链',
    outLinkInfo: '将数据发布为独立的公开链接, 无需登录即可访问数据',
    openOutLink: '开启数据外链',
    dataVisitAuth: '数据访问权限',
    openVisit: '公开访问',
    pwdVisit: '凭密码访问',
    fieldVisitAuth: '字段访问权限',
    setDataOutLink: '设置外链字段',
    dataInnerLink: '数据内链',
    openDataInnerLinkInfo: '开启数据内链, 通过平台移动端扫一扫功能可直接访问数据',
    openDataInnerLink: '开启数据内链',
    sameFieldOutLink: '可以将本模块哪些字段可以数据外链',
    fieldName: '字段名称',
    accessible: '可访问',
    selectVisitField: '选择可访问字段',
    setPwd: '设置密码',
    submitCheck: '提交校验',
    tipsText: '提示文字',
    shortmessageTemplate: '短信模版',
    shortmessageTemplateInfo: '设置字段值的校验规则, 防止不规范的数据录入。',
    addTemplate: '新建模版',
    templateContent: '模版内容',
    failBeacuse: '失败原因',
    shortMessTem25: '请输入名称，不得超过25个汉字',
    selsectSigntrue: '选择签名',
    pleaseSelsectSigntrue: '请选择签名',
    insertVar: '插入变量',
    tamplateNameRequried: '模板名称必填',
    tamplateContentRequried: '模板内容必填',
    applicationNotesRequried: '申请说明必填',
    tamplateSigntrueRequried: '模板签名必填',
    applicationNotes: '申请说明',
    shortmessTemMsg1: '请简略描述您的业务场景, 不超过100字',
    shortmessTemMsg2:
      '共19个字（含签名和括号）, 1条短信（因含有变量，按实际发送长度计费; 70字以内（含70字）计为1条, 超过70字按67/字1条计费）',
    shortmessTemMsg3: '短信模板需要进行审核, 审核工作时间：周一至周日 9:00-23:00 （法定节日顺延）',
    fieldIsNotInputAgain: '字段不存在, 请重新调整模板内容',
    sureDelShorMesTemplate: '确认要删除该短信模版吗?',
    delSuccessDontHuifu: '删除成功之后, 该操作将无法恢复',
    subMenu: '子菜单',
    subMenuInfo: '对已创建的自定义子菜单进行维护',
    query: '查询',
    sureDelData: '确认要删除该数据吗?',
    tagManage: '页签管理',
    tagManageInfo: '对已有的表单数据进行预计算（预处理）, 以备进一步调用',
    lookAllData: '可见所有关联数据',
    lookAuthData: '可见数据权限内的数据',
    show: '显示',
    hidden: '隐藏',
    controlModule: '控制模块',
    controlContion: '控制条件',
    addRule: '添加规则',
    newBuildRule: '新建规则',
    tabManageMsg1: '请确保所选字段在当前模块内值不重复,',
    tabManageMsg2: '否则页签可能会在数据上出现重复',
    defaultContion: '默认条件',
    showTange: '可见范围',
    tabStatus: '页签状态',
    dayu: '大于',
    xiaoyu: '小于',
    dayudengyu: '大于等于',
    xiaoyudengyu: '小于等于',
    dengyu: '等于',
    budengyu: '不等于',
    baohan: '包含',
    beibaohan: '被包含',
    bubaohan: '不包含',
    bubeibaohan: '不被包含',
    leijia: '累加',
    koujian: '扣减',
    fixedValue: '固定值',
    dynamicValue: '动态值',
    controlModuleNotEmpty: '控制模块不能为空',
    controlContionNotEmpty: '控制条件不能为空',
    topSuccess: '置顶成功',
    editRule: '编辑规则',
    tabDelRule: '删除后该规则控制的模块将从“自定义模块名称”的页签上移除?',
    sureTabDelRule: '你确定要删除选中规则吗?',
    others: '其他',
    reference: '关联关系',
    matchAuto: '匹配自动化',
    matchAutoInfo: '通过设定的匹配规则自动获取符合条件的数据',
    highSeasPool: '公海池',
    oneDayUpperLimit: '每日可领取上限',
    UpperLimit: '领取上限',
    administrators: '管理员',
    secrecyField: '保密字段',
    dontInputInfinite: '不填为无限制',
    addField: '添加字段',
    recoveryRule: '回收规则',
    notRecovery: '不回收',
    recovery: '回收',
    zhixingPinglv: '执行频率',
    everyday: '每天',
    everyday0clock: '每天0点执行',
    highseaspoolPwd: '可对公海池内的电话和电子邮箱组件做保密控制',
    selectPwdField: '选择要保密信息的字段',
    inputHighseaspollName: '请填写公海池名称',
    memberRequried: '成员必填',
    adminRequried: '管理员必填！',
    highseaspollNameishave: '该公海池名称已存在',
    limintmax: '领取上限不能小于每日领取上限',
    huishouRequried: '若选择回收, 则回收规则条件为必填',
    notSeasRule: '非公海池规则',
    returnHighseaspoll: '退回公海池',
    pleaseInputName: '请填写名称',
    notSeasRuleIshave: '该非公海池规则已存在',
    recoveryRuleRequried: '回收规则必填',
    returnHighseasRequried: '退回的公海池必填',
    noticePush: '消息推送',
    noticePushInfo: '基于某种条件发送消息提醒指定的成员',
    disable: '禁用',
    enable: '启用',
    trigger: '触发动作',
    remindTime: '提醒时间',
    beiRemindPer: '被提醒人',
    remindContent: '提醒内容',
    triggerEvent: '触发事件',
    anyField: '任意字段',
    zhidingField: '指定字段',
    zhidingFieldSet: '指定字段设置',
    thisDay: '当天',
    before: '之前',
    after: '之后',
    repeatReminder: '重复提醒频率',
    remindEndtiem: '提醒结束时间',
    remindFangshi: '提醒方式',
    selectShormsgTemplate: '选择短信模板',
    emailContent: '邮件内容',
    eventHappen: '事件发生时',
    customRemindTime: '自定义提醒时间',
    remindType: '提醒类型',
    remindPinglv: '提醒频率',
    every: '每',
    day: '天',
    week: '周',
    month: '月',
    year: '年',
    endTime: '结束时间',
    Happen: '发生',
    cizhihou: '次之后',
    result: '结果',
    pushContent: '推送内容',
    selectHappenTrigger: '请选择编辑数据时触发提醒的字段',
    neverGameOver: '永不结束',
    cishu: '次数',
    zhidingDate: '指定日期',
    dateTimeField: '日期/时间字段',
    onlyOneRmind: '仅提醒一次',
    dayRemind: '每天提醒',
    weekRemind: '每周提醒',
    monthRemind: '每月提醒',
    yearRemind: '每年提醒',
    addData: '新增数据',
    receivedNewYaoqing: '收到新的客户协作邀请',
    never: '永不',
    date: '日期',
    hao: '号',
    themeMustFill: '主题是必填项',
    senderMustFill: '发件人是必填项',
    addresseeeMustFill: '收件人是必填项',
    emailContentMustFill: '邮件内容是必填项',
    pleaseZhidingField: '请选择指定字段',
    pleaseZhidingTiem: '请选择提醒时间',
    noticePushMsg1: '提醒时间天数为必填正整数',
    noticePushMsg2: '提醒结束次数为必填正整数',
    noticePushMsg3: '提醒结束指定时间为必填',
    noticePushMsg4: '请选择提醒结束时间字段',
    noticePushMsg5: '提醒结束时间天数为必填正整数',
    noticePushMsg6: '请添加邮件内容',
    noticePushMsg7: '提醒人不能为空',
    noticePushMsg8: '新增规则成功',
    noticePushMsg9: '删除规则成功',
    noticePushMsg10: '此操作将禁用该规则, 是否继续?',
    noticePushMsg11: '此操作将启用该规则, 是否继续?',
    everyDay9DontOver: '每1天09:00，不结束',
    maxThreeDate: '最多只能添加三条数据',
    receiveNew: '收到新的',
    receiveShare: '收到共享的',
    benzhuanhuanNewData: '被转换为新模块数据',
    receiveTransfer: '收到被转移的',
    beiDel: '被删除',
    beiEdit: '数据被修改',
    beiCommon: '被评论',
    quickGenjin: '请及时跟进',
    neverOver: '不结束',
    ciOver: '次结束',
    over: '结束',
    workflowAtuo: '工作流自动化',
    workflowAtuoInfo:
      '将满足条件的记录自动执行设定的业务流程; 自动化涉及到字段更新、自动分配、字段转换、提醒等等',
    start: '开始',
    plus: '加',
    reduce: '减',
    newBuildUpdaInfo: '基于过滤条件对目标模块进行更新或新建数据操作。',
    operationMode: '操作方式',
    addAndUpdateData: '新建与更新数据',
    updateData: '更新数据',
    isApprovalProcess: '是否发起审批流',
    businessOperation: '业务操作',
    addOperation: '添加操作',
    targetModuleMustfill: '目标模块为必填项目',
    nameMustfill25: '名称为必填, 且25个字以内',
    approvalProcessInfo: '发起审批流程中无指定负责人, 请在业务操作中配置负责人对应关系',
    matchCondNotall: '匹配条件不完善',
    filterCondNotall: '过滤条件不完善',
    bussinessOpreationNotall: '业务操作不完善',
    tuijianModule: '推荐模块',
    updateTime: '更新时间',
    autoMatchCondNotEmpty: '自动化匹配条件不能为空',
    custonBottonInfo: '通过定义当用户点击按钮时执行的操作内容',
    custonBotton: '自定义按钮',
    name: '名称',
    buttonName: '按钮名称',
    buttonUser: '按钮使用人员',
    addUserDepRole: '添加成员、部门、角色',
    buttonShowPosition: '按钮显示位置',
    buttonShowContion: '按钮显示条件',
    AlwaysShow: '总是显示',
    thisCotntionShow: '满足以下条件时显示',
    clickButtonShowPop: '点击按钮后是否需要弹窗填写内容：',
    noNeed: '不需要',
    need: '需要',
    customButtonTips: '提示文字（提示文字为空则代表无须弹窗提示，直接执行后续规则）',
    determineNeedTriggeContent: '确认后需要触发更新内容',
    detailsPage: '详情页面',
    listPage: '列表页面',
    addNoduleData: '新增模块数据',
    fieldUpdateTrigge: '字段更新-触发后台规则',
    openUrl: '跳转链接',
    initiateApproval: '发起审批',
    pleaseInputButtonName: '请填写按钮名称',
    pleaseSelectButtonUser: '请选择按钮使用人员',
    pleaseSelectButtonPostion: '请选择按钮显示位置',
    popSelectOneFiled: '弹窗中最少选择一个字段',
    pleaseSelectTriggeModule: '请选择目标模块',
    pleaseSelectJumpSystem: '请填写跳转链接',
    roleAuth: '角色权限',
    pageAuth: '页面权限',
    fieldDependent: '字段依赖',
    optioneFieldControl: '选项字段控制',
    recordStyle: '记录样式',
    highSeasManage: '公海管理',
    notHighSeasRule: '非公海规则',
    externalLinks: '外部链接',
    viewManage: '视图管理',
    checkRepeatSettings: '查重设置',
    checkRepeatInfo: '通过复杂查重规则，排除人为操作出现的重复信息',
    dongtaiTime1: '动态时分-提前',
    dongtaiTime2: '动态时分-延后',
    wechatNoticeInfo:
      '该方式仅针对绑定了微信公众号的员工生效，未绑定微信公众号员工无法收到消息推送，如需绑定微信公众号请至【系统管理】-【基本信息】下的微信公众号访问中配置',
    fenbieSend: '分别发送',
    teshuMember: '特殊成员',
    teshuMember1: '特殊成员领取上限',
    teshuMember2: '特殊成员每日领取上限',
    teshuMember3: '领取限制',
    teshuMember4: '说明：数据被退回或者系统定时回收公海池后，前负责人在N天后不能领取。',
    teshuMember5: '天内不能连续领取同一条数据',
    highseaJudge1: '成员领取上限为正整数',
    highseaJudge2: '成员每日可领取上限为正整数',
    highseaJudge3: '特殊成员领取上限为正整数',
    highseaJudge4: '特殊成员每日领取上限为正整数',
    highseaJudge5: '领取限制为正整数',
    highseaJudge6: '特殊成员领取上限不能小于特殊成员每日领取上限',
    highseaJudge7: '领取限制最大输入值100',

    // 2020-12-25
    searchTargetModuleUpdate: '查询目标模块数据后更新到本模块中',
    emailTemplateSet: '邮件提醒模板',
    emailContentRemind: '邮件提醒内容',
    referenceYilaiInfoNew:
      '应用于为“关联关系”、“部门-单选”类型的字段, 实现两个关联关系之间、两个部门之间的数据过滤',
    gobackBusinessFlow: '返回企业工作流',
    BusinessFlowSet: '企业工作流设置',
    scheduleDataInfo1: '日程/待办事项组件呈现事件/执行人设置',
    scheduleDataInfo2: '日程/待办事项组件完成状态设置，完成的数据将划线标记为已完成任务',
    scheduleDataInfo3: '日程/待办事项卡片显示字段设置',
    scheduleDataInfo4: '根据表单数据推送到门户：日程/待办任务 不允许创建多个',
    scheduleDataInfo5: '日程/待办事项组件完成状态设置有误',

    // 2021-04-08
    everyMinute: '每分钟',
    triggerTiming: '触发定时',
    breakTimeTrigger: '在休息时间定时触发关闭',
    offDutyDay: '不上班工作日',
    offHours: '不上班时间段',
    noonBreak: '中午休息时间段',
    offHolidays: '法定节假日定时触发关闭',
    selectOffDutyDay: '请选择不上班工作日',
    selectOffHours: '请选择不上班时间段',
    selectNoonBreak: '请选择中午休息时间段',
    btnColor: '按钮颜色',
    smartPlugInfo:
      '使用该功能前请至【接口集成】--【第三方平台】--【阿里云集成】中设置对应阿里云接口帐户。',
    smartPlugTitle:
      '使用该功能，请先去【接口集成】菜单-【第三方平台】对应页签中进行设置，设置后才可使用',
    idCardShibie: '身份证实名识别',
    businessInfoSearch: '工商信息查询',
    sureCloseAndClear: '确定要关闭吗？关闭后字段设置将被清空',
    idCardRequired: '身份证信息必填',
    companyNameRequired: '企业名称必填',
    payFieldRequired: '支付字段必填',
    namePictureIdcard: '图片+姓名+身份证实名识别',
    verifyPictureNameIDcard: '用于校验图片、姓名和身份证号是否匹配，必填。',
    mapModeSettings: '地图模式设置',
    mapMode: '地图模式',
    showTabModule: '显示页签模块',
    mapModeSettingsTips:
      '用于在定位地图下，显示其它页签模块的数量以及支持点击数量查看列表，比如客户下的联系人。',
    selectTabModule: '选择页签模块',
    SubordinateTheStage: '所属阶段',
    mapModeTip1: '定位地图功能有必填项未填写',
    mapModeTip2: '显示页签模块有必填项未填写',
    deleteSchedule: '删除日程',
    deleteDataTriggerAdd: '删除当前数据触发的新建日程',
    deleteScheduleRequired: '删除日程必填',
    constFieldRequired: '常量字段必填',
    oprationPaymentSetTip: '执行操作【账期设置】的触发事件必须是【在新建记录保存后】',
    PaymentDaysSet: '账期设置'
  }
}
